import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Customer } from 'types/Customer'
import { useQuery } from '@tanstack/react-query'
import ROUTES from '../../../../config/routes'
import CustomerService from '../../services/customer.service'

const blankCustomer: Customer = {
  accessCode: '',
  city: '',
  contactEmail: '',
  country: 'COUNTRY_EE',
  eoriNumber: '',
  id: 0,
  maxGuaranteeAmount: 1,
  auditRequiredAmount: 1,
  guaranteeFormula: '',
  name: '',
  notes: '',
  registryCode: '',
  status: undefined,
  street: '',
  streetNumber: '',
  zipCode: '',
  documentFilesRequired: true,
  requiresAudit: true,
  remoteClientCode: '',
  profileStatus: '',
  isApiAccessEnabled: false,
}

function useCustomer(customerId?: string) {
  const [fetchedCustomer, setFetchedCustomer] = useState<Customer>(blankCustomer)
  const location = useLocation()
  const history = useNavigate()
  const [isExternalCustomer, setExternalCustomer] = useState(location.pathname.startsWith('/external-customer'))

  const { data } = useQuery({
    queryKey: ['/v1/customer', customerId],
    queryFn: async () => (await CustomerService.getCustomer(Number(customerId))),
    staleTime: Infinity, // never stale
    enabled: !!customerId,
  })

  useEffect(() => {
    if (customerId === undefined || data === undefined) {
      return
    }
    setFetchedCustomer(data)
    setExternalCustomer(data.external ?? false)
    if (data.external === true) {
      history(`${ROUTES.externalCustomer}/${data.id}`, { replace: true })
    } else {
      history(`${ROUTES.customer}/${data.id}`, { replace: true })
    }
  }, [data])

  const updateRemoteClientCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFetchedCustomer({
      ...fetchedCustomer,
      remoteClientCode: event.target.value,
    })
  }

  return {
    fetchedCustomer,
    setFetchedCustomer,
    updateRemoteClientCode,
    isExternalCustomer,
  }
}

export default useCustomer
